// Posts signup forms ([data-ked-signup] form) to Klaviyo's public subscribe endpoint. The list's
// double opt-in sends the confirmation mail; flows and segments pick the profile up through
// signup_source and, on lead magnet pages, lead_magnet.
(function () {
  if (window.__kedSignupBound) return;
  window.__kedSignupBound = true;

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('form[data-ked-signup]');
    if (!form) return;
    event.preventDefault();

    const root = form.closest('[data-ked-signup-root]');
    const status = root.querySelector('[data-ked-signup-status]');
    const button = form.querySelector('button[type="submit"]');
    const email = form.elements.email.value.trim();
    const data = form.dataset;

    const properties = { signup_source: data.signupSource };
    if (data.leadMagnet) properties.lead_magnet = data.leadMagnet;
    // The helmet checks write their answers into data-properties as JSON before the visitor submits.
    if (data.properties) {
      try {
        Object.assign(properties, JSON.parse(data.properties));
      } catch (error) {}
    }

    button.setAttribute('aria-busy', 'true');
    status.textContent = '';

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(data.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: data.customSource,
            profile: { data: { type: 'profile', attributes: { email: email, properties: properties } } }
          },
          relationships: { list: { data: { type: 'list', id: data.listId } } }
        }
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Klaviyo responded with ' + response.status);

        status.textContent = status.dataset.success;
        root.classList.add('is-done');

        const download = root.querySelector('[data-ked-signup-download]');
        if (download) download.hidden = false;

        // Same event shape as Klaviyo's own forms, so the GTM and PostHog lead listeners count this signup too.
        window.dispatchEvent(
          new CustomEvent('klaviyoForms', {
            detail: {
              type: 'submit',
              formId: data.formId,
              metaData: { $email: email, $source: data.customSource, signup_source: data.signupSource }
            }
          })
        );
      })
      .catch(function () {
        status.textContent = status.dataset.error;
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  });
})();
